<template>
  <div>
    <common-header title="설문조사" :showTitle="true" :showCart="false" :showHome="false" :showBack="false"/>
    <main class="survey_q_bg content">
      <div class="content">
        설문조사에 참여해주셔서 감사합니다.<br/>
        <br/>
        더 좋은 서비스로 보답하겠습니다.<br/>
      </div>
      <div>
        <button type="button" class="btn btn-full btn-primary footer-bottom" @click="changeSurveyMainView">쿠폰받기</button>
      </div>
    </main>
  </div>
</template>

<script>
import {AppConfig} from '@/config/AppConfig';
import {mapActions, mapGetters} from "vuex";
export default {
  data() {
    return {
      orderNo : null,
    }
  },
  created() {
    // 설문조사 조회
    const orderNo = this.$route.params.orderNo;
    this.orderNo = orderNo;
  },
  computed: {
  ...mapGetters(['fetchedSelectGuestSurvey'])
  },
  methods: {
    ...mapActions(['SELECT_GUEST_SURVEY']),
    changeSurveyMainView() {
      this.showLoading(true);
      this.SELECT_GUEST_SURVEY(this.orderNo)
        .then(response => {
          if (response.code !== '0000') {
            this.showAlert(response.message);
          }else{
            if(this.fetchedSelectGuestSurvey.answerYn === 'Y' && this.fetchedSelectGuestSurvey.surveyBenefitHistories.length > 0){
              window.location.href = AppConfig.VUE_APP_DOMAIN + 'gp_gift/accept.jsp?item_type=CPN&item_no='+this.fetchedSelectGuestSurvey.surveyBenefitHistories[0].couponNo;
            }
          }
        })
        .catch(error => this.showAlert("설문조사 조회에 실패했습니다."))
        .finally(() => this.showLoading(false))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/survey/SurveyGuestComplete.vue